import { render, staticRenderFns } from "./AnField.vue?vue&type=template&id=96110df2&scoped=true&"
import script from "./AnField.vue?vue&type=script&lang=js&"
export * from "./AnField.vue?vue&type=script&lang=js&"
import style0 from "./AnField.vue?vue&type=style&index=0&id=96110df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96110df2",
  null
  
)

export default component.exports